import "core-js/modules/es.number.constructor.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "loading",
  props: {
    setHeight: {
      type: Number,
      default: 350
    },
    loadTitle: {
      type: String,
      default: "载入中..."
    },
    isIcon: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup() {
    return {};
  },
  components: {}
});